//import vue functions
import { provide, watch } from "vue";
import type { InjectionKey, WatchCallback, WatchSource } from "vue";

/**
 * @function useWatchProvidedValue - composable that executes an action when a provided value changes
 * @param {string | number | InjectionKey<unknown>} symbol - symbol or name of the provided value
 * @param {(object | WatchSource<unknown>)[]}value - value to provide
 * @param {WatchCallback<(object | WatchSource<unknown>)[],(object | WatchSource<unknown>)[]>} callback - action to execute
 */
export default function useWatchProvidedValue(
  symbol: string | number | InjectionKey<unknown>,
  value: (object | WatchSource<unknown>)[],
  callback: WatchCallback<
    (object | WatchSource<unknown>)[],
    (object | WatchSource<unknown>)[]
  >
): void {
  //provide the value with the defined symbol
  provide(symbol, value);
  //watch the value to execute the action
  watch(value, callback);
}
